import React from 'react';
// import PropTypes from 'prop-types';

function Terms() {
  return (
    <div className="space-y-3 font-light text-justify">
      <p className="text-xl font-semibold">
        <strong>AYOS TERMS AND CONDITIONS </strong>
      </p>
      <p>
        <span>
          The Terms and Conditions contained in AYOS Mobile Application (“AYOS”
          or “Mobile App”) shall govern your (“you”, “User”, or “Player”) access
          and use of AYOS, including all pages to which you may be redirected.
        </span>
        These Terms and Conditions apply in full force and effect and by
        accessing and using this Mobile App, it is understood that you have
        read, understood, and agree to be bound by the same. You may choose not
        to access or use this Mobile App if you do not agree to any of these
        Terms and Conditions.
      </p>
      <p>
        Whenever used herein, the term “AYOS Mobile Application”, “AYOS” or
        “Mobile App” shall also mean “Multisys Technologies Corporation”, the
        legal owner of this Mobile App and this website.
      </p>
      <p className="text-lg font-medium">
        <strong>A. GENERAL</strong>
      </p>
      <p>
        You must be at least eighteen (18) years old to use this Mobile App.
        Nevertheless, children of all ages may use this Mobile App if enabled by
        a parent or legal guardian.
      </p>
      <p>
        If you are seventeen (17) years old and below, you represent that you
        have your parent or legal guardian’s permission to use and access this
        Mobile App. Have your parent or legal guardian read these Terms and
        Conditions with you.
      </p>
      <p>
        By accessing or using this Mobile App, you warrant that you are duly
        authorized to request access and supply information on your behalf. AYOS
        may, at its sole discretion, request additional or supporting proof to
        prove such authority.
      </p>
      <p>
        You also warrant that all information that will be supplied is verified
        and true and correct to the best of your knowledge.
      </p>

      <p className="text-lg font-medium">
        <strong>B. GRANT OF USE</strong>
      </p>
      <p>
        Once registered, AYOS grants you limited and non-exclusive access to use
        this Mobile App, which may be denied by AYOS at any time and at its sole
        discretion for violation or non-compliance with these Terms and
        Conditions.
      </p>

      <p className="text-lg font-medium">
        <strong>C. LAWFUL USE</strong>
      </p>
      <p>
        You agree that you will only use the Mobile App for lawful purposes.
      </p>

      <p className="text-lg font-medium">
        <strong>D. AYOS MOBILE APPLICATION; BASIC MECHANICS</strong>
      </p>
      <ul className="list-decimal">
        <li className="ml-12">
          Upon downloading AYOS, the User shall register to create his/her AYOS
          account by providing a valid mobile number wherein the OTP (SMS
          verification) will be sent, and a code name which the User shall use.
          You will be asked to create your six(6) digit password.
        </li>
      </ul>
      <p className="ml-16">
        a. Upon registration, Users create and customize Avatar for Ayos Mobile
        Application only.
      </p>
      <p className="ml-20">
        i. A default avatar is automatically created for the User upon
        registration.
      </p>
      <p className="ml-20">ii. The Avatar can be customized by the User:</p>
      <ul className="list-decimal">
        <li className="ml-28">Gender</li>
        <li className="ml-28">Facial Features</li>
        <li className="ml-28">Hair Features</li>
        <li className="ml-28">Eye Features</li>
        <li className="ml-28">Eyebrows Feature</li>
        <li className="ml-28">Nose Shape</li>
        <li className="ml-28">Mouth Shape</li>
        <li className="ml-28">Shirt Style</li>
        <li className="ml-28">Pants Style</li>
        <li className="ml-28">Shoe Style</li>
        <li className="ml-28">Accessories</li>
        <li className="ml-28">Background</li>
      </ul>

      <p className="ml-16">
        b. Users to play the games available in single-player and multi-player
        modes in the Ayos Mobile Application.
      </p>
      <p className="ml-20">
        i. The game list will be automatically provided to the User:
      </p>
      <ul className="list-decimal">
        <li className="ml-28">Jack N Poy</li>
        <li className="ml-28">Elesi</li>
        <li className="ml-28">Holen</li>
        <li className="ml-28">Patintero</li>
        <li className="ml-28">Teks</li>
        <li className="ml-28">Tumbang Preso</li>
        <li className="ml-28">Cara Cruz</li>
        <li className="ml-28">Tirador</li>
        <li className="ml-28">Hide and Seek</li>
        <li className="ml-28">Luksong Lubid</li>
        <li className="ml-28">Pitik Bulag</li>
      </ul>
      <p className="ml-20">
        ii. The service in the Mobile App is provided on an “as is” basis only.
        Nothing herein shall be construed as making any representation, whether
        expressed or implied, in relation to the quality, completeness, fitness
        for purpose or the accuracy of the Service, or the overall functionality
        of the Ayos Mobile App.
      </p>
      <p className="ml-20">
        iii. AYOS shall not be liable for any delay, buffering, or slow down in
        the videos, graphics, or the games itself.
      </p>
      <p className="ml-20">
        iv. At any time, AYOS may suspend the Mobile App, for any reason, upon
        reasonable notice and shall resume at our sole discretion as soon as
        practicable.
      </p>
      <p className="ml-20">
        v. If the player is found to use the Mobile App for any fraudulent
        purpose or illegal activity or is found to use abusive and/or indecent
        language to other players or our staff, AYOS reserves the right to
        immediately disconnect the Mobile App without prior notice and/or refuse
        to reconnect the service.
      </p>
      <p className="ml-20">
        vi. AYOS has the right to file legal action against the person or player
        concerned, and charge the appropriate fees if any.
      </p>
      <p className="ml-20">
        vii. The player shall likewise be liable to us for any and all
        compensation fees on any unauthorized activities and unauthorized
        commercial use of the Mobile App.
      </p>
      <p className="ml-20">
        viii. The compensation fee is payable, without any limitation, from the
        time the unauthorized activity occurred until the actual cessation
        thereof.
      </p>
      <p className="ml-20">
        ix. The player undertakes not to use the Mobile App for any activity
        that is contrary to morals and public policy or which violates any
        ordinance, law, decree, order, regulation, or treaty.
      </p>
      <p className="ml-20">
        x. The Player agrees to indemnify and hold AYOS free and harmless from
        any liability, suit, or damage arising from or connected with the
        Player’s unauthorized or illegal activities.
      </p>

      <p className="ml-12">2. Buy Gems</p>
      <p className="ml-16">
        a. When buying gems, the Player should only pay to AYOS’ authorized
        payment channels that will appear on the payment method options.
      </p>
      <p className="ml-20">
        i. Amount due is auto-populated depending on the number of gems the
        Player will buy.
      </p>
      <p className="ml-20">
        ii. Click “BUY GEMS” once you are done selecting the number of gems you
        will buy with their corresponding price.
      </p>
      <ul className="list-decimal">
        <li className="ml-28">
          Android - The following payment methods will appear on your screen:
          Banks, eWallets, Visa/Mastercard, Online Banking, ECPay Outlets, and
          Kiosk Machines. Click “Proceed” after choosing your preferred payment
          method.
        </li>
        <li className="ml-28">
          iOS - Apple In-app purchase will appear, select purchase and sign in
          to your with Apple ID then confirm the purchase.
        </li>
      </ul>
      <p className="ml-20">
        iii. Depending on the payment method used, the validation of your
        payment may take 5 minutes to 48 hours to be confirmed. Once payment is
        validated, the points/gems/coin will be credited to your account.
      </p>
      <p className="ml-16">
        b. The system fee, rates, and other charges will depend on the selected
        merchant of the Player.
      </p>
      <p className="ml-20">
        i. The Player agrees to pay and shoulder the system fee or any other
        charges deemed necessary for the disbursement, the amount of which shall
        depend on the purchase price to be paid. The player agrees that it shall
        be deducted from the available balance from the Player’s wallet or bank
        account. The amount of fees and charges may be changed anytime as we may
        deem necessary, without the need of prior notice.
      </p>
      <p className="ml-16">
        c. Sending statements of transactions after purchasing gems.
      </p>
      <p className="ml-20">
        i. AYOS shall send a copy of your requests via SMS. The mere act of
        sending the statement is a conclusive presumption that you have received
        the same. AYOS shall be held free and harmless from any and all
        liability should the Statement of Transactions be read by a person other
        than the player. You shall not thereafter raise the defense that you
        failed to receive the Statement of Transactions. In any case, you may
        inquire about the Statement of Transactions by contacting our customer
        support.
      </p>
      <p className="ml-16">d. Disputes on Purchasing or Buying Gems</p>
      <p className="ml-20">
        i. Disputed transactions shall only be credited back to your account
        once the claim/dispute has been properly processed, investigated, and
        proven to be in your favor. Players should submit a duly filled out
        request for reversal and send the same thru mail or email to us.
        Reversals will only be made upon proper verification and validation.
      </p>
      <p className="ml-20">
        ii. The details in the SMS/Text confirmation message after every
        transaction and/or the details in the Statement of Transactions are
        presumed true and correct unless the Player notifies us in writing of
        any disputes thereon within twelve (12) hours from the date of
        transaction. If no dispute is reported within the said period, all
        transactions shall be deemed conclusively true and correct.
      </p>

      <p className="ml-12">3. Account Security</p>
      <p className="ml-16">
        a. All transactions made using the account are conclusively presumed to
        be made by the Player and he/she shall be liable for such.
      </p>
      <p className="ml-16">
        b. The security and proper care of your account, as well as
        confidentiality of PINs, OTP, and credentials, shall be the Player’s
        sole responsibility.
      </p>
      <p className="ml-16">
        c. You acknowledge that the use of any third parties linked to any of
        our features is done strictly at the Player’s risk.
      </p>
      <p className="ml-20">
        i. We will not be held liable for any losses or damages suffered by the
        Player due to the use of third parties. The Player agrees to indemnify
        and hold us free and harmless from any liability, suit, or damage
        arising from or connected with the Player’s use of AYOS or use of such
        third parties.
      </p>

      <p className="text-lg font-medium">
        <strong>E. RESTRICTIONS</strong>
      </p>
      <p>
        You are expressly and emphatically restricted from all of the following:
      </p>
      <ul className="list-disc">
        <li className="ml-16">
          Selling, sublicensing, and/or otherwise commercializing the Ayos
          Mobile App;
        </li>
        <li className="ml-16">
          Using the Ayos Mobile App or any of the information in illegal or
          unlawful activities;
        </li>
        <li className="ml-16">
          Publicly performing and/or showing any Ayos Mobile App material like
          video streaming;
        </li>
        <li className="ml-16">
          Using the Ayos Mobile App in any way that is, or may be damaging;
        </li>
        <li className="ml-16">
          Using the Ayos Mobile App in any way that impacts user access to this
          Mobile App;
        </li>
        <li className="ml-16">
          Using the Ayos Mobile App contrary to applicable laws and regulations,
          or in a way that causes, or may cause, harm to the Mobile App, or to
          the Owner or any person or organization;
        </li>
        <li className="ml-16">
          Engaging in any data mining, data harvesting, data extracting, or any
          other similar activity in relation to the Ayos Mobile App, or while
          using the Ayos Mobile App;
        </li>
        <li className="ml-16">
          Using the Ayos Mobile App to engage in any advertising or marketing;
        </li>
        <li className="ml-16">
          Certain areas of the Ayos Mobile App are restricted from access by you
          and by the Owner may further restrict access by you to any areas of
          this Mobile App, at any time, in its sole and absolute discretion. The
          personal information you may have shared for the Ayos Mobile App is
          confidential.
        </li>
      </ul>

      <p className="text-lg font-medium">
        <strong>F. PROFILE</strong>
      </p>
      <p>
        All information that you will provide herein shall be treated as
        confidential. With respect to the information, you agree to grant AYOS a
        full view of your information (as may be applicable based on the
        information supplied) and also allow the latter to use the information
        if needed subject to the Data Privacy Act of 2012.
      </p>
      <p>
        By using and accessing the Mobile App, you also agree to AYOS’ PRIVACY
        NOTICE and that you agree to exercise the same diligence as the Mobile
        App Owner in implementing the AYOS’ Privacy policy.
      </p>

      <p className="text-lg font-medium">
        <strong>G. LIMITATION OF LIABILITY</strong>
      </p>
      <p>
        In no event shall AYOS nor any of its officers, directors, and
        employees, be liable to you for anything arising out of or in any way
        connected with your use of AYOS, whether such liability is under
        contract, tort, or otherwise, and AYOS, including its officers,
        directors, and employees shall not be liable for any indirect,
        consequential or special liability arising out of or in any way related
        to your use of this Mobile App or any breach therein.
      </p>

      <p className="text-lg font-medium">
        <strong>H. INDEMNIFICATION</strong>
      </p>
      <p>
        You hereby agree to indemnify to the fullest extent and hold AYOS, and
        each of its officers and employees harmless from and against any and all
        liabilities, costs, demands, causes of action, damages, and expenses
        (including reasonable attorney’s fees) arising out of or in any way
        related to your breach of any of the provisions of these Terms and
        Conditions, and the Privacy Notice.
      </p>

      <p className="text-lg font-medium">
        <strong>I. UPDATE IN TERMS</strong>
      </p>
      <p>
        AYOS is permitted to revise these Terms and Conditions at any time as it
        sees fit, and by using this Mobile App, you are expected to review such
        Terms and Conditions on a regular basis to ensure you understand all
        terms and conditions governing the use of this Mobile App.
      </p>

      <p className="text-lg font-medium">
        <strong>J. SEVERABILITY</strong>
      </p>
      <p>
        If any of the provisions of these Terms and Conditions is held to be
        invalid or unenforceable, the validity or enforceability of the
        remaining provisions shall remain and be affected thereby, and continue
        to be in full force and effect.
      </p>

      <p className="text-lg font-medium">
        <strong>K. GOVERNING LAW</strong>
      </p>
      <p>
        The validity and interpretation of the Terms and Conditions shall be
        governed and construed in accordance with the laws of the Republic of
        the Philippines. In case of dispute or controversy as to the validity,
        interpretation, and violation of these Terms and Conditions, the venue
        of action shall be the appropriate courts of Parañaque City to the
        exclusion of all other courts.
      </p>

      <p className="text-lg font-medium">
        <strong>L. CONTACT US</strong>
      </p>
      <p>
        If you have any questions pertaining to this Mobile App or any of the
        Terms and Conditions contained herein, please contact AYOS at
        inquiry@multisyscorp.com or support@gamebox.ph.
      </p>
    </div>
  );
}

Terms.propTypes = {};

export default Terms;
